<template>
    <component :is="layout">
        <router-view />
    </component>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { TokenService } from "@services";
import { tracer } from "@/diagnostics/tracer.js";

tracer.init();

export default {
    name: "App",

    computed: {
        ...mapGetters("settings", ["settings"]),

        layout() {
            return this.$route.meta.layout || "default-layout";
        },
    },

    metaInfo: {
        titleTemplate: "%s | Ranes",
    },

    methods: {
        ...mapActions("user", ["setUser", "setUserCreds"]),
        ...mapActions("heartbeat", ["checkHeartbeat"]),

        async init() {
            if (TokenService.getToken()) {
                await this.setUser();
                await this.setUserCreds();
                await this.checkHeartbeat();
            }
        },
    },

    mounted() {
        if (this.layout == "share-layout") {
            this.$vuetify.theme.dark = false;
        } else if (this.settings.darkTheme != null) {
            this.$vuetify.theme.dark = this.settings.darkTheme;
        } else {
            this.$vuetify.theme.dark = true;
        }

        this.init();
    },
};
</script>
